import { useCallback } from 'react';

import { useStorageState } from '@/hooks/use-storage-state';

const STORAGE_KEY = 'pref.dashboardTasksEnabled';

export function useDashboardTasks(): {
	enabled: boolean;
	isLoading: boolean;
	setEnabled: (value: boolean) => void;
	} {
	const [[isLoading, raw], setValue] = useStorageState(STORAGE_KEY);

	const setEnabled = useCallback((value: boolean) => {
		setValue(value ? 'true' : null);
	}, [setValue]);

	return {
		enabled: raw === 'true',
		isLoading,
		setEnabled,
	};
}
